module.exports = __webpack_public_path__ + "img/master-visaul.4bcfab3e.png";